import React, { useState, useCallback } from 'react';
import { translations } from '../languages.js';
import { useSettings } from '../hooks/useSettings.js';
import { useTranslation } from '../hooks/useTranslation.js';
import { useTTS } from '../hooks/useTTS.js';
import { useZaloEvents } from '../hooks/useZaloEvents.js';

import Header from '../components/Header.js';
import TranslatorInput from '../components/TranslatorInput.js';
import TranslatorOutput from '../components/TranslatorOutput.js';
import Footer from '../components/Footer.js';
import SettingsModal from '../components/SettingsModal.js';

import './global.css';

const KoVnTranslatorPage = () => {
    const [provider, setProvider] = useState('AI A');
    const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);

    const [settings, setSettings] = useSettings('ko-vn');

    const t = useCallback((key) => {
        const get = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);
        const lang = settings.sourceLang || 'ko';
        const translationObj = get(translations, key);

        if (!translationObj) {
            console.warn(`번역 키를 찾을 수 없습니다: ${key}`);
            return key;
        }
        if (typeof translationObj[lang] !== 'undefined') {
            return translationObj[lang];
        }
        return translationObj;
    }, [settings.sourceLang]);

    const {
        sourceLang,
        sourceText,
        targetText,
        isLoading,
        error,
        isCharLimitExceeded,
        handleSourceChange,
        handleTranslate,
        handleSwap,
        handleClear,
        handleCopy,
        copySuccess,
        isCoolingDown,
        cooldownSeconds,
    } = useTranslation(settings, setSettings, provider, t, 'ko-vn');

    const { handleTTS } = useTTS(sourceLang);

    useZaloEvents();

    return (
        <div className="container">
            <Header pageType="ko-vn" />
            <main className="translator-area">
                <TranslatorInput
                    pageType="ko-vn"
                    sourceLang={sourceLang}
                    sourceText={sourceText}
                    settings={settings}
                    setSettings={setSettings}
                    t={t}
                    isCharLimitExceeded={isCharLimitExceeded}
                    isLoading={isLoading}
                    isCoolingDown={isCoolingDown}
                    cooldownSeconds={cooldownSeconds}
                    handleSourceChange={handleSourceChange}
                    handleTranslate={handleTranslate}
                    handleSwap={handleSwap}
                    handleClear={handleClear}
                />
                <TranslatorOutput
                    pageType="ko-vn"
                    sourceLang={sourceLang}
                    targetText={targetText}
                    isLoading={isLoading}
                    error={error}
                    t={t}
                    copySuccess={copySuccess}
                    handleCopy={handleCopy}
                    handleTTS={() => handleTTS(targetText)}
                    openSettings={() => setSettingsModalOpen(true)}
                />
            </main>
            <SettingsModal
                show={isSettingsModalOpen}
                onClose={() => setSettingsModalOpen(false)}
                settings={settings}
                setSettings={setSettings}
                t={t}
            />
            <Footer provider={provider} setProvider={setProvider} />
        </div>
    );
}

export default KoVnTranslatorPage;
